import Vue from "vue";

import ChangeMajorForm from "./components/ChangeMajorForm.vue";
import UserSearchView from "./components/user-search/UserSearchView";
import UserProfileEditView from "./components/user-edit/UserProfileEditView.vue";
import SendMessageView from "./components/send-message/SendMessageView";
import SendBulkMessageView from "./components/send-message/SendBulkMessageView";
import LogInteractionView from "./components/log-interaction/LogInteractionView";
import UserListView from "./components/user-list/UserListView";
import UserProfileView from "./components/user-view-profile/UserProfileView";
import ImportUsersView from "@/components/import-users/ImportUsersView";
import UserAddForm from "./components/user-add/UserAddForm";
import Dashboard from "@/components/dashboard/Dashboard";
// importing all bootstrap vue components is too much!
// import used bootstrap vue components into each component that needs them
// add the css though (only about 8K zipped)

import "./components/lib/custom.scss";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";

// register only top-level view components that will be used directly in the
// C# application
const Components = {
  ChangeMajorForm,
  Dashboard,
  ImportUsersView,
  LogInteractionView,
  SendBulkMessageView,
  SendMessageView,
  UserAddForm,
  UserListView,
  UserProfileEditView,
  UserProfileView,
  UserSearchView
};

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});

export default Components;
